import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiServiciosInstance, authHeaderServicios } from "../../redux/actions/servicios/servicios";

import { Form, Input, Button, Row, Col, Typography, Space, InputNumber, Switch } from "antd";
import { toast } from "../../components/toasts/toastStore";

import "./EventosPage.css";
import "./PaquetesPage.css";

const { Title, Text } = Typography;

export default function CrearServicioPage() {
  const navigate = useNavigate();
  const { idServicio } = useParams();
  const isEditing = !!idServicio;

  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const usaTarifaCopias = Form.useWatch("usa_tarifa_copias", form);

  useEffect(() => {
    if (!isEditing) return;
    apiServiciosInstance.get(`/servicios/${idServicio}`, { headers: authHeaderServicios() })
      .then((res) => {
        const s = res.data ?? {};
        form.setFieldsValue({
          nombre: s.nombre,
          precio_base: s.precio_base != null ? parseFloat(s.precio_base) : undefined,
          tasa_iva: s.tasa_iva != null ? parseFloat(s.tasa_iva) : undefined,
          usa_tarifa_copias: Boolean(s.usa_tarifa_copias),
        });
      })
      .catch(() => toast.error("No se pudo cargar el servicio"));
  }, [idServicio]);

  const handleSave = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    const payload = {
      nombre: values.nombre?.trim(),
      precio_base: values.usa_tarifa_copias ? null : values.precio_base ?? null,
      tasa_iva: values.tasa_iva != null ? values.tasa_iva : null,
      usa_tarifa_copias: Boolean(values.usa_tarifa_copias),
    };

    setSaving(true);
    try {
      if (isEditing) {
        await apiServiciosInstance.patch(`/servicios/${idServicio}`, payload, { headers: authHeaderServicios() });
        toast.success("Servicio actualizado correctamente");
      } else {
        await apiServiciosInstance.post("/servicios", payload, { headers: authHeaderServicios() });
        toast.success("Servicio creado exitosamente");
      }
      navigate("/app/servicios");
    } catch (err) {
      toast.error(err?.response?.data?.detail || err.message || "Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="paq-main">
      <div className="paq-content">
        <section className="cc-page-header-card">
          <Space direction="vertical" size={2}>
            <Title level={2} className="eventos-title" style={{ marginBottom: 0 }}>
              {isEditing ? "Editando servicio" : "Nuevo servicio"}
            </Title>
            <Text className="eventos-subtitle">
              {isEditing
                ? "Modifica los datos del servicio y guarda los cambios."
                : "Completa los datos del servicio para registrarlo en el sistema."}
            </Text>
          </Space>

          <Space>
            <Button className="eventos-btn-clean" onClick={() => navigate("/app/servicios")} disabled={saving}>
              Cancelar
            </Button>
            <Button
              type="primary"
              loading={saving}
              icon={!isEditing ? <i className="fa-solid fa-plus" /> : null}
              onClick={handleSave}
              style={{ backgroundColor: "#f90336", borderColor: "#f90336" }}
            >
              {isEditing ? "Guardar cambios" : "Crear servicio"}
            </Button>
          </Space>
        </section>

        <Form form={form} layout="vertical" initialValues={{ usa_tarifa_copias: false }}>
          <div className="cc-section-card">
            <div className="cc-section-header">
              <span className="cc-section-icon"><i className="fa-solid fa-print"></i></span>
              Datos del servicio
            </div>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="nombre"
                  label={<span className="paq-field-label">Nombre del servicio</span>}
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <Input placeholder="Ej. Fotocopias, Tramite de licencia..." autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="tasa_iva" label={<span className="paq-field-label">Tasa de IVA % (opcional)</span>}>
                  <InputNumber style={{ width: "100%" }} min={0} max={100} precision={2} placeholder="16.00" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="usa_tarifa_copias"
                  label={<span className="paq-field-label">Usa tarifa por rango de hojas</span>}
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
                <Text style={{ fontSize: 12, color: "#64748b", display: "block", marginTop: -8 }}>
                  Activalo si el precio de este servicio se calcula por rango de hojas (fotocopias en blanco y negro o color).
                </Text>
              </Col>
              {!usaTarifaCopias && (
                <Col xs={24} md={12}>
                  <Form.Item name="precio_base" label={<span className="paq-field-label">Precio</span>}>
                    <InputNumber style={{ width: "100%" }} min={0} precision={2} placeholder="0.00" />
                  </Form.Item>
                </Col>
              )}
            </Row>

            {usaTarifaCopias && (
              <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: 14, marginTop: 4 }}>
                <Text style={{ fontSize: 13, color: "#374151" }}>
                  Las tarifas por rango de hojas se administran desde el detalle del servicio, una vez creado.
                </Text>
              </div>
            )}
          </div>
        </Form>
      </div>
    </main>
  );
}
